import { render, staticRenderFns } from "./SupplierEdit.vue?vue&type=template&id=18c98c08&"
import script from "./SupplierEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports